import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  CheckoutResponse,
  ShippingMethod,
} from '../../dto/response/checkout.response';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import {
  ClearCheckoutAction,
  InitCheckoutAction,
  PaymentMethodAction,
  ShippingMethodAction,
  SippingAddressAction,
} from '../actions/checkout.action';
import { CheckoutService } from '../../service/checkout.service';

export interface CheckoutModelState {
  checkout?: CheckoutResponse;
}

@State<CheckoutModelState>({
  name: 'checkout',
  defaults: {
    checkout: {} as CheckoutResponse,
  },
})
@Injectable()
export class CheckoutState {
  constructor(private checkoutService: CheckoutService) {}

  @Selector()
  static checkout(state: CheckoutModelState): CheckoutResponse {
    return <CheckoutResponse>state.checkout;
  }

  @Selector()
  static shippingMethod(
    state: CheckoutModelState,
  ): ShippingMethod[] | undefined {
    return state.checkout?.shipping_methods;
  }

  @Action(InitCheckoutAction)
  initCheckout(
    ctx: StateContext<CheckoutModelState>,
    action: InitCheckoutAction,
  ) {
    return this.checkoutService.initCheckout(action.checkoutInitRQ).pipe(
      tap({
        next: (result: CheckoutResponse) => {
          const state = ctx.getState();
          ctx.setState({
            ...state,
            checkout: result,
          });
        },
        error: (err) => {
          throw new Error(err?.error?.message);
        },
      }),
    );
  }

  @Action(ClearCheckoutAction)
  clearCart(ctx: StateContext<CheckoutModelState>) {
    return ctx.patchState({
      checkout: {} as CheckoutResponse,
    });
  }

  @Action(SippingAddressAction)
  shippingAddressAction(
    ctx: StateContext<CheckoutModelState>,
    action: SippingAddressAction,
  ) {
    return this.checkoutService
      .setShippingAdress(action.checkoutId, action.shippingAddress)
      .pipe(
        tap({
          next: (result: CheckoutResponse) => {
            const state = ctx.getState();
            ctx.setState({
              ...state,
              checkout: result,
            });
          },
          error: (err) => {
            throw new Error(err?.error?.message);
          },
        }),
      );
  }

  @Action(ShippingMethodAction)
  shippingMethodAction(
    ctx: StateContext<CheckoutModelState>,
    action: ShippingMethodAction,
  ) {
    return this.checkoutService
      .selectShippingMethod(action.checkoutId, action.shippingMethod)
      .pipe(
        tap({
          next: (result: CheckoutResponse) => {
            const state = ctx.getState();
            ctx.setState({
              ...state,
              checkout: result,
            });
          },
          error: (err) => {
            throw new Error(err?.error?.message);
          },
        }),
      );
  }

  @Action(PaymentMethodAction)
  paymentMethodAction(
    ctx: StateContext<CheckoutModelState>,
    action: PaymentMethodAction,
  ) {
    return this.checkoutService
      .selectPaymentMethod(action.checkoutId, action.paymentMethod)
      .pipe(
        tap({
          next: (result: CheckoutResponse) => {
            const state = ctx.getState();
            ctx.setState({
              ...state,
              checkout: result,
            });
          },
          error: (err) => {
            throw new Error(err?.error?.message);
          },
        }),
      );
  }
}
